var _circle, _circle2, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBylineIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 17,
    r: 9,
    fill: "#7F7F7F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 6,
    height: 8,
    fill: "#7F7F7F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5847 28C36.5909 35.612 29.1747 41 20.5 41C11.8253 41 4.40912 35.612 1.41534 28H39.5847Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBylineIcon11);
export default __webpack_public_path__ + "static/media/BylineIcon11.5ec157d27f94e99b865d056f73f2b3e2.svg";
export { ForwardRef as ReactComponent };